module.exports = __webpack_public_path__ + "img/PR7679.6e0ec67a.png";